import { render, staticRenderFns } from "./VirtualScrollbar.vue?vue&type=template&id=b4c88f30&"
import script from "./VirtualScrollbar.vue?vue&type=script&lang=ts&"
export * from "./VirtualScrollbar.vue?vue&type=script&lang=ts&"
import style0 from "./VirtualScrollbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports